import { compose, getContext, withProps } from 'recompose';
import PropTypes from 'prop-types';
import { withMyAccountTranslate } from '../../hoc';
import { GamblingHelpSection } from './GamblingHelpSection';
import { GamblingHelpSectionTracker } from '@myaccount/tracker';

var enhance = compose(getContext({ langCode: PropTypes.string }), withMyAccountTranslate, withProps(function () {
  return {
    tracker: new GamblingHelpSectionTracker()
  };
}));

var enhancedGamblingHelpSection = enhance(GamblingHelpSection);

export { enhancedGamblingHelpSection as GamblingHelpSection };